export var SocketMessageCommand;
(function (SocketMessageCommand) {
    SocketMessageCommand["SIGNER_DISCONNECT"] = "signer_disconnect";
    SocketMessageCommand["SIGNER_CONNECT"] = "signer_connect";
    SocketMessageCommand["REQUEST_SIGNATURE"] = "request_signature";
    SocketMessageCommand["REQUEST_SIGN_TRANSACTION"] = "request_sign_transaction";
    SocketMessageCommand["SIGN_TRANSACTION"] = "sign_transaction";
    SocketMessageCommand["REQUEST_LOCK"] = "request_lock";
    SocketMessageCommand["NOTIFY_TRANSACTION_BROADCASTED"] = "notify_transaction_broadcasted";
    SocketMessageCommand["TRANSACTION_BROADCASTED_NOTIFICATION"] = "transaction_broadcasted_notification";
    SocketMessageCommand["TRANSACTION_ERROR_NOTIFICATION"] = "transaction_error_notification";
})(SocketMessageCommand || (SocketMessageCommand = {}));
export var MultisigStep;
(function (MultisigStep) {
    MultisigStep["ACCEPT_REJECT_TRANSACTION"] = "ACCEPT_REJECT_TRANSACTION";
    MultisigStep["NOTIFY_TRANSACTION_BROADCASTED"] = "NOTIFY_TRANSACTION_BROADCASTED";
    MultisigStep["SIGN_TRANSACTION_FEEDBACK"] = "SIGN_TRANSACTION_FEEDBACK";
    MultisigStep["UNLOCK_WALLET"] = "UNLOCK_WALLET";
    MultisigStep["NOTIFY_ERROR"] = "NOTIFY_ERROR";
})(MultisigStep || (MultisigStep = {}));
